
import React, { useEffect, useRef, useState } from 'react';
import { useQuery } from "@tanstack/react-query";
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly';
import { getMedallists } from "data/Querys";
import { useLabels } from 'components/general/Label';
import Loader from "components/general/Loader";
import NotAvailable from "components/common/NotAvailable";
import PageHeader from 'components/common/PageHeader';
import { Stack } from 'react-bootstrap';
import SelectorDiscipline from 'components/common/selectors/selector-discipline/selectorDiscipline';
import SelectorNoc from 'components/common/selectors/selector-noc';
import { ALL_URL, SELECTOR_DISPLAY_TYPE } from "helpers/utils";
import MultiMedallistTable from 'components/common/medals/MultiMedallistsTable';
import { ResetFilterButton } from 'components/common/ResetFilterButton';


export default function MultiMedallists() {
    const fLabel = useLabels()
    const header = fLabel({ data: 'MultiMedallists' });
    const [dataState, setDataState] = useState([]);
    const [competitorFilter, setcompetitorFilter] = useState();
    const [nocsList, setNocsList] = useState([]);
    const [disciplinesList, setDisciplinesList] = useState([]);
    const { mirs_competition, mirs_language, mirs_discipline } = useUrlFriendlyToParameters();
    const inputRef = useRef(null);
    const [selectedNoc, setSelectedNoc] = useState('');
    const placeholder = fLabel({ data: 'LabelCompetitor' });
    const { data, isError, isLoading } = useQuery(
        {
            queryKey: ['multimedallists', mirs_competition, mirs_language],
            queryFn: getMedallists,
            refetchInterval: 5000,
            staleTime: 5000,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error'],
            //enabled: !!confCategory
            onError: (error) =>
                console.error(`Something went wrong: ${error.message}`),
        });

    useEffect(() => {
        let filterData = data?.medallist || [];
        const athData = {};
        filterData?.forEach(m => {
            m.athletes.forEach(ath => {
                const singleData = { athlete: ath, discipline: m.discipline, medal_type: m.medal_type, eventUnit: m.eventUnit };
                if (ath?.athlete?.code) {
                    if (!athData.hasOwnProperty(ath.athlete.code)) {
                        athData[ath.athlete.code] = [singleData]
                    } else {
                        athData[ath.athlete.code].push(singleData);
                    }
                }
            })
        });

        const medalsCount = {};

        for (const playerId in athData) {
            if (athData.hasOwnProperty.call(athData, playerId)) {
                const playerData = athData[playerId];
                if (playerData?.length > 1) {

                    for (const medalInfo of playerData) {
                        const medal = medalInfo.medal_type;
                        if (!medalsCount[playerId]) {
                            medalsCount[playerId] = { events: [], medals: { "1": 0, "2": 0, "3": 0, total: 0 }, athlete: medalInfo.athlete.athlete };
                        }
                        medalsCount[playerId]['medals'][medal]++;
                        medalsCount[playerId]['medals']['total']++;
                        medalsCount[playerId]['events'].push({ eventUnit: medalInfo.eventUnit, discipline: medalInfo.discipline, medal_type: medalInfo.medal_type });
                    }
                }
            }
        };
        let playerRanking = Object.entries(medalsCount).map(([, athData]) => athData).sort((a, b) => {
            // compare gold
            const goldCompare = b.medals["1"] - a.medals["1"];
            // compare silver
            const silverCompare = b.medals["2"] - a.medals["2"];
            // compare bronze
            const bronzeCompare = b.medals["3"] - a.medals["3"];

            //compare noc
            const nocCompare = a.athlete.organisation?.code.toLowerCase().localeCompare(b.athlete.organisation?.code.toLowerCase());
            // compare name

            const nameCompare = a.athlete.TVName.toLowerCase().localeCompare(b.athlete.TVName.toLowerCase());

            return goldCompare || silverCompare || bronzeCompare || nocCompare || nameCompare;
        });

        playerRanking.forEach(pl => {
            pl.events.sort((a, b) => {
                const disciplineCompare = a.discipline.description.toLowerCase().localeCompare(b.discipline.description.toLowerCase());
                const medalCompare = a.medal_type - b.medal_type;
                const eventOrderCompare = a?.eventUnit?.order - b?.eventUnit?.order
                return disciplineCompare || medalCompare || eventOrderCompare;
            })
        });
        let rank = 1;
        let highRank = 1;
        let prevMedals = { ...playerRanking?.[0]?.medals || {} };
        for (const obj of playerRanking) {
            // check if 2 cons items are the same rank
            if (prevMedals["1"] === obj.medals["1"] && prevMedals["2"] === obj.medals["2"] && prevMedals["3"] === obj.medals["3"]) {
                obj.rank = rank;
                highRank++;
            } else {
                rank = highRank;
                highRank++
                obj.rank = rank;
                prevMedals = obj.medals;
            };
        }

        const uniqueCountryCodesSet = new Set();
        const uniqueDisciplinesCodesSet = new Set();
        if (mirs_discipline && mirs_discipline !== ALL_URL.ALL_DISC) {
            if (selectedNoc && selectedNoc !== ALL_URL.ALL_NOC) {
                playerRanking?.forEach(pr => {
                    if (pr?.events?.some(e => e?.discipline?.code === mirs_discipline)) {
                        if (pr?.athlete?.organisation?.code) {
                            uniqueCountryCodesSet.add(pr?.athlete?.organisation?.code);
                        }
                    }
                });

                playerRanking?.forEach(pr => {
                    if (pr?.athlete?.organisation?.code === selectedNoc) {
                        if (pr?.events?.length > 0) {
                            pr?.events?.forEach(ev => {
                                if (ev?.discipline?.code) {
                                    uniqueDisciplinesCodesSet.add(ev.discipline.code)

                                }
                            });
                        }
                    }
                });
            } else {
                playerRanking?.forEach(pr => {
                    if (pr?.events?.some(e => e?.discipline?.code === mirs_discipline)) {
                        if (pr?.athlete?.organisation?.code) {
                            uniqueCountryCodesSet.add(pr?.athlete?.organisation?.code);
                        }
                    }
                });

                playerRanking?.forEach(pr => {
                    if (pr?.events?.length > 0) {
                        pr?.events?.forEach(ev => {
                            if (ev?.discipline?.code) {
                                uniqueDisciplinesCodesSet.add(ev.discipline.code);
                            }
                        });
                    }
                });
            }
        } else {
            if (selectedNoc && selectedNoc !== ALL_URL.ALL_NOC) {
                playerRanking?.forEach(pr => {
                    if (pr?.athlete?.organisation?.code) {
                        uniqueCountryCodesSet.add(pr?.athlete?.organisation?.code);
                    }
                });
                playerRanking?.forEach(pr => {
                    if (pr?.athlete?.organisation?.code === selectedNoc) {
                        if (pr?.events?.length > 0) {
                            pr?.events?.forEach(ev => {
                                if (ev?.discipline?.code) {
                                    uniqueDisciplinesCodesSet.add(ev.discipline.code)

                                }
                            });
                        }
                    }
                });
            } else {
                playerRanking?.forEach(pr => {
                    if (pr?.athlete?.organisation?.code) {
                        uniqueCountryCodesSet.add(pr?.athlete?.organisation?.code);
                    }
                });

                playerRanking?.forEach(pr => {
                    if (pr?.events?.length > 0) {
                        pr?.events?.forEach(ev => {
                            if (ev?.discipline?.code) {
                                uniqueDisciplinesCodesSet.add(ev.discipline.code)

                            }
                        });
                    }
                });
            }
        }

        setDisciplinesList([...uniqueDisciplinesCodesSet]);
        setNocsList([...uniqueCountryCodesSet]);

        if (mirs_discipline && mirs_discipline !== ALL_URL.ALL_DISC) {
            playerRanking = playerRanking.map(d => ({ ...d, events: d.events.filter(item => item?.discipline?.code === mirs_discipline) })).filter(e => e?.events?.length > 0);
        }

        if (selectedNoc && selectedNoc !== ALL_URL.ALL_NOC) {
            playerRanking = playerRanking.filter(item => item?.athlete?.organisation?.code === selectedNoc);
        }

        if (competitorFilter) {
            playerRanking = playerRanking.filter(item => item?.athlete?.name?.toLowerCase().includes(competitorFilter.toLowerCase()));
        };

        setDataState(playerRanking || []);
    }, [data, mirs_discipline, selectedNoc, competitorFilter]);

    const onSelectNoc = (nocCode) => {
        setSelectedNoc(nocCode)
    };

    const handleOnChange = event => {
        const { name, value } = event.target;
        setcompetitorFilter(value);
    };

    const clearFilterText = () => {
        if (inputRef?.current?.value) {
            inputRef.current.value = "";
        }
        setcompetitorFilter("");
    };

    const onClearFilters = () => {
        setSelectedNoc('');
        clearFilterText();
    }

    if (isError) { return <NotAvailable label="LabelNoDataAvailable" />; }
    if (isLoading) { return <Loader />; }
    if (!data?.medallist) { return <NotAvailable label="LabelNoDataAvailable" /> }

    return (
        <>
            <PageHeader title={header} />
            <div className='mirs-page-container'>
                <Stack direction="horizontal" className='selectors-container'>
                    <SelectorDiscipline display_type={SELECTOR_DISPLAY_TYPE.COMBO} page="multimedallists" disciplinesList={disciplinesList} useDisciplinesList={true} />
                    <SelectorNoc page="multimedallists" nocsList={nocsList} useNocList={true} onSelectNoc={onSelectNoc} selectedNoc={selectedNoc} />
                    <div className="d-flex competitor-search">
                        <input type="text" ref={inputRef} className="form-control" name="Competitor" id="Competitor"
                            placeholder={placeholder}
                            onChange={handleOnChange} />
                    </div>
                    <ResetFilterButton clearFilterText={clearFilterText} filterText={competitorFilter} page='multimedallists' selectedNoc={selectedNoc} onClearFilters={onClearFilters} />
                </Stack>
                {dataState && <MultiMedallistTable data={dataState} key={`multimedallists`} />}
            </div>
        </>
    )
};

